import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBiometrics = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      d="M3.75 9.7v-4c0-.69.56-1.25 1.25-1.25h4a.75.75 0 1 0 0-1.5H5A2.75 2.75 0 0 0 2.25 5.7v4a.75.75 0 0 0 1.5 0ZM15 4.45h4c.69 0 1.25.56 1.25 1.25v4a.75.75 0 0 0 1.5 0v-4A2.75 2.75 0 0 0 19 2.95h-4a.75.75 0 0 0 0 1.5ZM20.25 18.7v-4a.75.75 0 0 1 1.5 0v4A2.75 2.75 0 0 1 19 21.45h-4a.75.75 0 0 1 0-1.5h4c.69 0 1.25-.56 1.25-1.25ZM9 19.95H5c-.69 0-1.25-.56-1.25-1.25v-4a.75.75 0 0 0-1.5 0v4A2.75 2.75 0 0 0 5 21.45h4a.75.75 0 0 0 0-1.5Z"
    />
    <path
      fill="#F7A600"
      d="M10.25 9.7a1.95 1.95 0 1 1 3.9 0 1.95 1.95 0 0 1-3.9 0Zm1.95-3.45a3.45 3.45 0 0 0-2.365 5.962A5.25 5.25 0 0 0 6.95 16.9a.75.75 0 0 0 1.5 0 3.75 3.75 0 0 1 7.5 0 .75.75 0 0 0 1.5 0 5.25 5.25 0 0 0-2.885-4.688A3.45 3.45 0 0 0 12.2 6.25Z"
    />
  </svg>
);
export default SvgTwoColorBiometrics;
